// TermsAndConditions.jsx

import React from 'react';
import './TermsConditions.css';
// import Header from '../../Components/Header/Header';
// import Footer from '../../Components/Footer/Footer';
const TermsAndConditions = () => {
    return (
        <>
        {/* <Header/> */}
        <div className="terms-container">
            <h1>Terms & Conditions</h1>
            <p className='terms-container-p'>
           <b>Welcome to Media Dunes!           </b> <br />
           These terms and conditions outline the rules and regulations for using the Media Dunes website, located at mediadunes.com. By accessing this website, you agree to these terms. If you disagree, please refrain from using Media Dunes.
           <br />
           <b>Our Terms and Conditions
           </b>
           <li>	<b>Terminology:</b> "Client," "You," and "Your" refer to you, the website user. "The Company," "Ourselves," "We," "Our," and "Us" refer to Media Dunes. "Party," "Parties," or "Us" refer to both you and Media Dunes.</li> 
           <li><b>	Cookies:</b> We use cookies to improve your experience. By accessing Media Dunes, you consent to our use of cookies as outlined in our Privacy Policy.
           </li>
           <li>	<b>Intellectual Property:</b> Media Dunes or its licensors own all intellectual property rights for the website content. You may access this content for personal use only, subject to the limitations set forth in these terms.
           </li>
            <br />
            <h2><b>  Restrictions on Use:</b></h2>
            <ul>You are not permitted to: </ul>
            <li>Sell, rent, or sub-license Media Dunes content.</li>
            <li>Reproduce, duplicate, or copy Media Dunes content. </li>
            <li>Redistribute Media Dunes content.            </li>
<h2><b>User-Generated Content:
</b></h2>
Certain areas of the website allow users to post and exchange information. Media Dunes does not filter, edit, publish, or review comments before they appear on the website. Comments reflect the views and opinions of the individual who posted them, not Media Dunes. We are not liable for any comments or damages caused by their use or appearance on the website.   <br /> <br />
Media Dunes reserves the right to monitor all comments and remove any that are considered inappropriate, offensive, or in violation of these terms.   <br />

<b> Warranties and Representations:</b>
 <br />
 By using this website, you warrant and represent that:

<ul>
    <li>You have the right to post comments and possess all necessary licenses and consents to do so.
    </li>
    <li>Your comments do not violate any intellectual property rights of any third party.    </li>
    <li>Your comments are not defamatory, libelous, offensive, indecent, or unlawful.
    </li>
    <li>Your comments will not be used for solicitation, promotion, or unlawful activity.   
    </li>
    </ul>

            
    You hereby grant Media Dunes a non-exclusive license to use, reproduce, edit, and authorize others to use, reproduce, and edit any of your comments in any and all forms, formats, or media.   <br /> <br />

    <h4><b>Linking to Our Content
    </b></h4> 
    Organizations may link to our website without prior written approval if:

<ul>
    <li>They are government agencies, search engines, news organizations, online directory distributors linking in the same manner as to other businesses, or accredited businesses (excluding non-profits, charity shopping malls, and fundraising groups).
    </li>
    </ul>
   <p> Organizations must ensure their links:</p>
<ul>
    <li>Are not deceptive.
    </li>
    <li>	Do not falsely imply sponsorship, endorsement, or approval.
    </li>
    <li>Fit within the context of the linking party's site.</li>
</ul>
We reserve the right to approve or deny link requests from other organizations, considering factors like: 
<ul>

    <li>Potential impact on our reputation.</li>
    <li>The organization's record with us.</li>
    <li>The benefit of visibility compared to the absence of a Media Dunes link.
    </li>
    <li>Whether the link is in the context of general resource information.
    </li>
</ul> 
     Approved organizations may link to our homepage as long as the link:
<ul>
    <li>Is not deceptive.
    </li>
    <li>Does not falsely imply sponsorship, endorsement, or approval.</li>
    <li>Fits within the context of the linking party's site.</li>
</ul>
            
            
           <h2><b>iFrames
           </b></h2>  
           You may not create frames around our webpages that alter the visual presentation of our website without prior written permission<br />
            <h2>Content Liability
            </h2>
          <p>  We are not responsible for any content appearing on your website. You agree to protect and defend us against any claims arising from your website. No link(s) should appear on any website that may be interpreted as libelous, obscene, or criminal, or which infringes on any third-party rights.  </p> 
             
           </p>
        </div>

        {/* <Footer/> */}
        </>
    );
};

export default TermsAndConditions;
